import React, {useMemo} from "react";
import {App} from "@codeArt/apps";
import {requestUrl} from "@codeArt/utils/url";
import {useDispatch} from "react-redux";
import {main,uploadUrl} from "project/constant/host";
import lazy from "@codeArt/apps/lazy";
import DashboardIcon from "@material-ui/icons/Dashboard";
import { ExplorerConfig } from '@codeArt/components/explorer/index'
import {getRoutes,getMenus} from "@codeArt/apps/page/auth/export";
import {getRoutes as getExtensionRoutes,getMenus as getExtensionMenus} from "@codeArt/apps/page/extension/admin/export";

function getSettingMenus(matchUrl){
  return [
    ...getMenus(`${matchUrl}/setting`)
  ];
}

let getSidebar = function({matchUrl}){
  const start = [
    {
      name: "项目管理",
      type: "item",
      icon: <DashboardIcon />,
      link: `${matchUrl}/solution/index`
    }
  ];

  const menus = [
    {
      name: "开始",
      type: "section",
      children: start
    },
    {
      name: "插件",
      type: "section",
      children: getExtensionMenus(matchUrl)
    },
    {
      name: "设置",
      type: "section",
      children: getSettingMenus(matchUrl)
    }
  ];

  const buttons = [
    // {
    //   title: {
    //     text: "帮助文档",
    //     color: "#5D9405"
    //   },
    //   icon: <HelpOutlineIcon />,
    //   backgroundColor: "#D7F5B1",
    //   link: "https://docs.easyview.top/"
    // }
  ];

  let passage = [];

  return {menus, buttons, passage};
};

const Admin = ({match}) => {
  const dispatch = useDispatch();
  const matchUrl = requestUrl(match);

  const layout = {
    // header:{hidden:true},
    // sidebar:{hidden:true},
    footer: {hidden: true}
  };

  const routes = [
    {
      path: `${matchUrl}/solution/index`,
      component: lazy(() => import("./solution/index")),
      default: true
    },
    {
      path: `${matchUrl}/solution/track`,
      component: lazy(() => import("./solution/track"))
    },
    ...getRoutes(`${matchUrl}/setting`),
    ...getExtensionRoutes(matchUrl)
  ];

  const init = success => {

    // 初始化文件上传的相关配置
    ExplorerConfig.set({
      domain: uploadUrl,
    });

    success();
  };

  const sidebar = useMemo(() => getSidebar({matchUrl}), []);

  return (
    <App
      name="admin"
      auth={{role: "sa"}}
      request={{ domain: main, upload: uploadUrl}}
      getLayout={() => layout}
      routes={routes}
      init={init}
      getSidebar={() => sidebar}
      dispatch={dispatch}
    />
  );
};

export default Admin;

